import React, { useMemo } from "react";
import ReportViewer from "./components/ReportViewer";
import { generateStandardReportPdf } from "./utils/reportPdfGenerators";

export default function TopModelsReport() {
  const columns = useMemo(
    () => [
      { name: "Manufacturer", selector: (r) => r.Manufacturer || "-" },
      { name: "Model", selector: (r) => r.ModelName || "-" },
      { name: "Sold", selector: (r) => r.SoldCount ?? 0 },
    ],
    []
  );

  const currentYear = new Date().getFullYear();

  return (
    <ReportViewer
      reportKey="topModels"
      title="Top Models"
      columns={columns}
      fetchConfig={{
        url: "/reports/app2/top-models",
        paramsBuilder: (filters) => ({
          year: Number(filters.year || currentYear),
        }),
      }}
      initialFilters={{ year: currentYear }}
      renderFilters={(filters, setFilters) => (
        <div className="col-sm-12 col-md-2">
          <label className="form-label">Year</label>
          <input
            type="number"
            className="form-control"
            value={filters.year || currentYear}
            onChange={(e) => setFilters((p) => ({ ...p, year: e.target.value }))}
          />
        </div>
      )}
      buildKpis={(rows) => [{ label: "Models", value: rows?.length ?? 0 }]}
      pdfGenerator={generateStandardReportPdf}
    />
  );
}

